import { render, staticRenderFns } from "./selectitemgroups.vue?vue&type=template&id=1ac9917a&scoped=true&"
import script from "./selectitemgroups.vue?vue&type=script&lang=js&"
export * from "./selectitemgroups.vue?vue&type=script&lang=js&"
import style0 from "./selectitemgroups.vue?vue&type=style&index=0&id=1ac9917a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ac9917a",
  null
  
)

export default component.exports